import {HTMLAttributes} from 'react';
import {colors} from 'patient-ping-remedy/packages/theme';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import ToolTip from 'patient-ping-remedy/packages/tool-tip';
import {Wrapper} from '@common/widgets/WidgetElementViewed.styles';

type Props = HTMLAttributes<HTMLButtonElement> & {
  viewed: boolean;
  disabled: boolean;
  concise?: boolean;
};

export default function WidgetElementViewed({ viewed, disabled, concise, ...props }: Props) {
  const hoverText = viewed ? 'Mark as unread' : 'Mark as read';

  return (
    <Wrapper disabled={disabled} concise={concise} {...props}>
      <ToolTip html={hoverText} type="dark">
        <Icon
          iconClass={ICONS.circle}
          weight={viewed ? 'far' : 'fas'}
          color={colors.tertiary2}
          iconSize="1x"
        />
      </ToolTip>
    </Wrapper>
  );
}
